export * from "./FadeIn";
export * from "./MaskInMedia";
export * from "./SlideInText";

export type UIAnimationProps = {
  visible?: boolean;
  delay?: number;
  addDelay?: any[];
};
